(function () {
    'use strict';

    angular.module('PWAPoCApp').factory('rfidErrorModalService', rfidErrorModalService);

    rfidErrorModalService.$inject = ['$kWindow', 'translateService', '$rootScope'];

    function rfidErrorModalService($kWindow, translateService, $rootScope) {
        var service = {
            openRfidErrorModal,
        };

        return service;
        
        function openRfidErrorModal(errorMsg) {

                $rootScope.isRfidError = true;
                const window = $kWindow.open({
                    options: {
                        modal: true,
                        title: translateService.translate('rfidErrorModal.modalHeader'),
                        draggable: false,
                        movable: false,
                        resizable: false,
                        visible: false,
                    },
                    templateUrl: 'app/shared/rfidErrorModal/rfid-error-modal-view.html',
                    windowTemplateUrl: 'app/shared/modal-base.html',
                    controller: 'RfidErrorModalController',
                    resolve: {
                        errorMsg: () => errorMsg,
                    }
                });

        }
    }
})();
